// src/components/Header.jsx
import React, { useEffect, useState } from "react";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { fetchAboutDetails, fetchSiteDetails, fetchInstututeDetails, fetchAdmissionDetails } from "./api/Api";
import "../css/Header.css";

const GOOGLE_SCRIPT_ID = "google-translate-element-script";
const GOOGLE_STYLE_ID = "google-translate-hide-style";

const Header = () => {
  // UI state
  const [lang, setLang] = useState(localStorage.getItem("site_lang") || "en");

  // Site data
  const [aboutData, setAboutDetails] = useState({});
  const [siteData, setSiteDetails] = useState({});
  const [institute_data, setInstituteDetails] = useState({});
  const [admission_data, setAdmissionDetails] = useState({});

  useEffect(() => {
    fetchAboutDetails((data) => {
      if (Array.isArray(data) && data.length > 0) {
        setAboutDetails(data[0]);
      }
    });
  }, []);

  useEffect(() => {
    fetchSiteDetails((data) => {
      if (Array.isArray(data) && data.length > 0) {
        setSiteDetails(data[0]);
      }
    });
  }, []);

  useEffect(() => {
    fetchInstututeDetails((data) => {
      if (Array.isArray(data) && data.length > 0) {
        setInstituteDetails(data[0]);
      }
    });
  }, []);

  useEffect(() => {
    fetchAdmissionDetails((data) => {
      if (Array.isArray(data) && data.length > 0) {
        setAdmissionDetails(data[0]);
      }
    });
  }, []);


  // Zoom
  const [zoom, setZoom] = useState(1);
  useEffect(() => {
    document.body.style.zoom = zoom;
  }, [zoom]);

  // Avoid script errors
  useEffect(() => {
    const onError = (e) => {
      if (e?.message === "Script error.") {
        e.preventDefault();
        return true;
      }
    };
    window.addEventListener("error", onError);
    return () => window.removeEventListener("error", onError);
  }, []);

  // Load Google Translate script
  useEffect(() => {
    if (document.getElementById(GOOGLE_SCRIPT_ID)) return;

    window.googleTranslateElementInit = () => {
      try {
        if (!window.google?.translate) return;
        const container = document.getElementById("google_translate_element");
        if (!container) return;
        if (container.querySelector(".goog-te-gadget-simple")) return;

        new window.google.translate.TranslateElement(
          {
            pageLanguage: "en",
            includedLanguages: "en,mr",
            layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
            autoDisplay: false,
          },
          "google_translate_element"
        );
      } catch (err) {}
    };

    const script = document.createElement("script");
    script.id = GOOGLE_SCRIPT_ID;
    script.src =
      "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);

    if (!document.getElementById(GOOGLE_STYLE_ID)) {
      const style = document.createElement("style");
      style.id = GOOGLE_STYLE_ID;
      style.innerHTML = `
        .goog-te-gadget { display: none !important; }
        iframe.goog-te-banner-frame { display: none !important; }
        .goog-logo-link { display: none !important; }
        .goog-te-spinner-pos { display: none !important; }
        #goog-gt-tt { display: none !important; }
        .goog-tooltip { display: none !important; }
      `;
      document.head.appendChild(style);
    }
  }, []);

  // Remove duplicate translator boxes
  useEffect(() => {
    const removeDuplicates = () => {
      const gadgets = document.querySelectorAll(".goog-te-gadget-simple");
      if (gadgets.length <= 1) return;
      for (let i = 1; i < gadgets.length; i++) {
        gadgets[i].remove();
      }
    };
    const interval = setInterval(removeDuplicates, 500);
    const stopper = setTimeout(() => clearInterval(interval), 3000);
    return () => {
      clearInterval(interval);
      clearTimeout(stopper);
    };
  }, []);

  // Apply language
  const applyGoogleLanguage = (targetLang) => {
    localStorage.setItem("site_lang", targetLang);
    setLang(targetLang);

    const interval = setInterval(() => {
      const combo = document.querySelector(".goog-te-combo");
      if (combo) {
        combo.value = targetLang;
        combo.dispatchEvent(new Event("change", { bubbles: true }));
        clearInterval(interval);
      }
    }, 200);

    setTimeout(() => clearInterval(interval), 2000);
  };

  useEffect(() => {
    const saved = localStorage.getItem("site_lang") || "en";
    if (saved) applyGoogleLanguage(saved);
  }, []);

  

  

  // Zoom handlers
  const decreaseZoom = () => setZoom((z) => Math.max(z - 0.1, 0.9));
  const resetZoom = () => setZoom(1);
  const increaseZoom = () => setZoom((z) => Math.min(z + 0.1, 1.1));

  return (
    <>
      {/* Hidden Google widget */}
      <div id="google_translate_element" style={{ display: "none" }} />

      {/* Header top */}
      <div className="container-fluid py-2 header-top text-center">
        <div className="header-flex d-flex justify-content-center align-items-center flex-wrap">

          {/* LEFT LOGO */}
          <Link to="/" className="header-logo">
            <img src={siteData.left_logo} alt="" className="img-fluid" />
          </Link>

          {/* TITLE CENTER */}
          <div className="header-text text-center mx-3">
            <h2 translate="no" className="site-title">{siteData.title}</h2>
            <h4 translate="no" className="sub-title">{siteData.tagline}</h4>
            <h3 translate="no" className="marathi-title">
              <strong>{siteData.tagline2}</strong>
            </h3>
          </div>
          <Link to="/" className="header-logo">
          <img
              src={siteData.right_logo}
              alt="Right Logo"
              className="right-logo img-fluid mb-1"
              style={{  }}
            />
          </Link>
          {/* RIGHT SIDE SECTION */}
          <div className="d-flex flex-column align-items-end">

            {/* MOVED CONTROLS TO RIGHT SIDE BELOW LOGO */}
            <div className="top-controls d-flex align-items-center justify-content-end gap-3 mt-2">
              <div className="Zoom-controls">
                <button onClick={decreaseZoom}>A-</button>
                <button onClick={resetZoom}>A</button>
                <button onClick={increaseZoom}>A+</button>
              </div>

              <select
                value={lang}
                onChange={(e) => applyGoogleLanguage(e.target.value)}
                className="lang-select"
              >
                <option value="en">English</option>
                <option value="mr">मराठी</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* NAVBAR */}
      <Navbar expand="lg" className="custom-navbar">
        <Container className="no-max">
          <Navbar.Toggle aria-controls="basic-navbar-nav" />

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">

              <Nav.Link as={Link} to="/">Home</Nav.Link>

              <NavDropdown title="About Us" id="about-dropdown">
                <NavDropdown.Item as={Link} to="/vision-mission/">
                  Vision & Mission
                </NavDropdown.Item>
                <NavDropdown.Item href={aboutData.organization_structure} target="_blank">
                  Organization Structure
                </NavDropdown.Item>
                <NavDropdown.Item href={aboutData.citizen_charter} target="_blank">
                  Citizen Charter
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/rtinew/">
                  RTI-Information
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title="Sections" id="sections-dropdown">
                <NavDropdown.Item as={Link} to="/accounts-section/">
                  Accounts Section
                </NavDropdown.Item>

                <NavDropdown.Item as={Link} to="/computer/">
                  Computer Section
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/confidential/">Confidential Section</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/dispatch/">Dispatch Section</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/establishment-section/">Establishment Section</NavDropdown.Item>

                <NavDropdown.Item as={Link} to="/technical-section/">
                  Technical & Academic Section
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title="Admission" id="admission-dropdown">
                <NavDropdown.Item href={admission_data.degree_pg_link} target="_blank">{admission_data.degree_pg_title}</NavDropdown.Item>
                <NavDropdown title="Diploma After 10th" drop="end">
                  <NavDropdown.Item href={admission_data.diploma_engg_link} target="_blank">
                    {admission_data.diploma_engg_title}
                  </NavDropdown.Item>
                </NavDropdown>
                <NavDropdown title="Diploma After 12th" drop="end">
                  <NavDropdown.Item href={admission_data.direct_2nd_yr_link} target="_blank">{admission_data.direct_2nd_yr_title}</NavDropdown.Item>
                  <NavDropdown.Item href={admission_data.diploma_hmct_link} target="_blank">{admission_data.diploma_hmct_title}</NavDropdown.Item>
                  <NavDropdown.Item href={admission_data.diploma_pharmacy_link} target="_blank">{admission_data.diploma_pharmacy_title}</NavDropdown.Item>
                  <NavDropdown.Item href={admission_data.diploma_surface_coating_link} target="_blank">{admission_data.diploma_surface_coating_title}</NavDropdown.Item>
                </NavDropdown>
              </NavDropdown>

              <NavDropdown title="Institutes" id="institutes-dropdown">
                <NavDropdown.Item as={Link} to="/institute-abstract/">Institute-Abstract</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/diploma-inst/">Diploma Institute</NavDropdown.Item>
                <NavDropdown.Item href={institute_data.degree_pdf} target="_blank">Degree Institutes</NavDropdown.Item>
                <NavDropdown.Item href={institute_data.post_grad_pdf} target="_blank">Post Graduation Institutes</NavDropdown.Item>
              </NavDropdown>
              
               

              <Nav.Link as={Link} to="/circular/">Circular</Nav.Link>
              <Nav.Link as={Link} to="/scholarships/">Scholarship</Nav.Link>
              <Nav.Link as={Link} to="/grievance/">Grievance-Form</Nav.Link>
              <Nav.Link as={Link} to="/useful-links/">Important Links</Nav.Link>
              <Nav.Link as={Link} to="/contact-us/">Contact Us</Nav.Link>

            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Header;
